import { createContext, PropsWithChildren } from "react";
import { Component, Feature, PermissionType, UserPermissionDTO } from "../../services/generated";


export interface IUserPayload extends PropsWithChildren{
    id: any,
    userPermissions?: UserPermissionDTO[] | null
}

export interface PermissionAuthContext {
    setUser: (user: IUserPayload) => void;
    isAuthorized: (feature? : Feature,
        component? : Component, permission? : PermissionType) => boolean;
    getUserAllowedOptions: (feature? : Feature,
        component? : Component, permission? : PermissionType, keyName? : string) => Array<number>;
    isLoading: boolean;
    hasAccess: boolean;
}

const noUser = (): never => {
    throw new Error("You didn't set User!");
};

const PermissionContext = createContext<PermissionAuthContext>({
    setUser: noUser,
    isAuthorized: noUser,
    getUserAllowedOptions:  noUser,
    isLoading: false,
    hasAccess: false
});

export default PermissionContext;